<template>
  <v-container grid-list-md fluid>
    <v-layout wrap justify-center align-center>
      <v-flex xs12 sm8>
        <v-btn color="primary" @click="create" class="mb-4" :disabled="!pessoa.isOwner">
          {{ this.translate("system.button.add.title") }}
          <v-icon dark>{{ this.translate("system.button.add.icon") }}</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>

      <!--Index-->
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          class="elevation-1"
          :rows-per-page-items="[100, 50, 25, { text: 'Todos', value: -1 }]"
          rows-per-page-text="Registros por página"
          no-data-text="Não existem registros"
          no-results-text="Nenhum registro encontrado"
        >
          <template slot="items" slot-scope="props">
            <td>
              {{
                translate("value.contato_tipo").filter((a) => a.value == props.item.tipo)[0].text
              }}
            </td>
            <td>{{ props.item.id_texto }}</td>
            <td align="center">
              <v-btn icon class="mx-0" @click="editItem(props.item)" :disabled="!pessoa.isOwner">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn icon class="mx-0" @click="deleteItem(props.item)" :disabled="!pessoa.isOwner">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="pageText" slot-scope="props">
            {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="1600px" persistent>
      <v-card>
        <v-card-text>
          <v-container grid-list-md fluid>
            <v-layout wrap justify-center align-center>
              <v-flex xs12>
                <span class="display-1">{{ formTitle }}</span>
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                  :label="translate('table.' + entity + '.field.tipo')"
                  v-model="editedItem.tipo"
                  :items="translate('value.contato_tipo')"
                  v-validate="'required'"
                  name="tipo"
                  :error-messages="errors.collect('tipo')"
                  :data-vv-as="translate('table.' + entity + '.field.tipo')"
                ></v-select>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  :label="translate('table.' + entity + '.field.id_texto')"
                  v-model="editedItem.id_texto"
                  name="id_texto"
                  counter
                  maxlength="60"
                  v-validate="'required'"
                  data-vv-validate-on="blur"
                  :error-messages="errors.collect('id_texto')"
                  :data-vv-as="translate('table.' + entity + '.field.id_texto')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-btn class="mx-1" color="primary darken-2" :disabled="saving" :loading="saving" @click.native="save()">Salvar</v-btn>
                <v-btn class="mx-1" @click.native="close(400)">Cancelar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
tr td:last-child {
  min-width: 130px;
}
</style>

<script>
import crud from "./../../mixin/crud";

export default {
  mixins: [crud],
  data: () => ({
    entity: "pessoa_contato",
    items: [],
  }),
  name: "Contato",
  props: ["pessoa_id", "values", "pessoa"],
  created() {
    this.items = this.values;
    this.editedItem = { pessoa_id: this.pessoa_id };
    this.defaultItem = { pessoa_id: this.pessoa_id };
  },
  computed: {
    headers: function () {
      return [
        {
          text: this.translate("table." + this.entity + ".field.tipo"),
          value: "tipo",
          width: "20%",
        },
        {
          text: this.translate("table." + this.entity + ".field.id_texto"),
          value: "id_texto",
          width: "60%",
        },
        {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/details/Contato.vue